import React from 'react';
import "../../../../css/global/labels/hiddenLabel.scss";



const HiddenLabel = ({labelFor, labelText}: {labelFor?: string, labelText: string}) => {
    
    return (
        <label htmlFor={labelFor} className='hidden-label'>
            {labelText}
        </label>
    )
}
export default HiddenLabel;